import React, { useState } from 'react';
import axios from 'axios';
import { useApi } from '@/contexts/AuthContext';
import { toast } from 'sonner';
import { Link2, Check } from 'lucide-react';

export const PortalLinkButton = ({ policyId }) => {
  const api = useApi();
  const [busy, setBusy] = useState(false);
  const [copied, setCopied] = useState(false);

  const generate = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/policies/${policyId}/portal-link`);
      try {
        await navigator.clipboard.writeText(data.url);
        setCopied(true);
        toast.success('Client portal link copied to clipboard', { description: data.url });
        setTimeout(() => setCopied(false), 3000);
      } catch {
        toast.info('Client portal link', { description: data.url, duration: 15000 });
      }
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Could not create portal link');
    }
    setBusy(false);
  };

  return (
    <button onClick={generate} disabled={busy} data-testid="portal-link-btn"
      className="flex items-center gap-1.5 px-3 py-2 rounded-md text-xs font-medium disabled:opacity-50"
      style={{ background: 'rgba(232,160,32,0.10)', color: '#B27516' }}>
      {copied ? <Check className="w-3.5 h-3.5" /> : <Link2 className="w-3.5 h-3.5" />}
      {busy ? 'Creating…' : copied ? 'Link Copied' : 'Client Portal Link'}
    </button>
  );
};

export default PortalLinkButton;
